import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Icon } from '@fnacdarty/back-office-ui';

import {
	StyledSortContainer,
	StyledIconContainer,
	StyledSortListContainer,
	StyledSortItem,
} from './index.styled';

const ActivitySort = ({ filters, setFilters }) => {
	const SORT_BY = [
		{
			label: 'Client',
			value: 'customer',
			path: 'customer.name',
			type: 'string',
		},
		{
			label: 'Date de planification',
			value: 'date',
			path: 'date',
			type: 'date',
		},
		{
			label: "Type d'activité",
			value: 'activity',
			path: 'activityType',
			type: 'string',
		},
		{
			label: 'Semaine',
			value: 'week',
			path: 'week',
			type: 'date',
		},
		{
			label: 'Code postal',
			value: 'zipCode',
			path: 'customer.zipCode',
			type: 'string',
		},
		{
			label: 'Intervenant',
			value: 'resource',
			path: 'resource.name',
			type: 'string',
		},
		{
			label: 'Traitement',
			value: 'processStatus',
			path: 'processStatus',
			type: 'boolean',
		},
	];

	const [showList, setShowList] = useState(false);

	const displaySortList = (e) => {
		e.stopPropagation();
		setShowList(!showList);
	};

	const updateSortOrder = () => {
		setFilters({
			...filters,
			sort: {
				...filters.sort,
				order: filters.sort.order === 'asc' ? 'desc' : 'asc',
			},
		});
	};

	const updateSortBy = (newSort) => {
		setFilters({
			...filters,
			sort: {
				...filters.sort,
				by: newSort,
			},
		});
		setShowList(false);
	};

	useEffect(() => {
		const handleOutsideClick = () => {
			setShowList(false);
		};

		if (!showList) {
			document.removeEventListener('click', handleOutsideClick);
		} else if (showList) {
			document.addEventListener('click', handleOutsideClick);
		}
		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	}, [showList]);

	if (!filters?.sort) {
		return null;
	}

	return (
		<StyledSortContainer>
			Trier par : &nbsp;
			<StyledIconContainer
				$isSorted={filters.sort.by.value !== ''}
				onClick={displaySortList}
			>
				<Icon name="adjustments" width={30} />
			</StyledIconContainer>
			Ordre de tri :&nbsp;
			<StyledIconContainer>
				<Icon
					name={
						filters.sort.order === 'asc'
							? 'sort-ascending'
							: 'sort-descending'
					}
					width={30}
					onClick={updateSortOrder}
				/>
			</StyledIconContainer>
			<StyledSortListContainer $showList={showList}>
				{/* <StyledTitle level={3}>Trier par</StyledTitle> */}
				{SORT_BY.map((item) => {
					const isActive = item.value === filters.sort.by.value;
					return (
						<StyledSortItem
							key={item.value}
							onClick={() => updateSortBy(item)}
							$isActive={isActive}
						>
							{item.label}
						</StyledSortItem>
					);
				})}
			</StyledSortListContainer>
		</StyledSortContainer>
	);
};

ActivitySort.propTypes = {
	filters: PropTypes.object.isRequired,
	setFilters: PropTypes.func.isRequired,
};

export default ActivitySort;
